<template>
    <div>
        <div
            class="cursor-pointer"
            @click.stop="isOpen = !isOpen">
            <strong class="segment-category inline-s">Starred</strong>
            <v-icon icon="caret-right" :class="{'is-rotating-right': isOpen}"/>
        </div>
        <ul
            v-if="isOpen"
            class="list list-group list-compact margin-top-s">
            <li
                class="list-item"
                v-for="segment in segments"
                :key="`starred_${segment.$internalId}`">
                <segment-link :segment="segment"/>
            </li>
        </ul>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import SegmentLink from '@/modules/segments/components/segment-link';
    import {mapGetters} from 'vuex';

    export default {
        name: 'starred-segments',
        components: {vIcon, SegmentLink},
        props: {
            segments: Array,
        },
        computed: {
            ...mapGetters({
                activeSegment: 'segments/activeSegment',
            }),
        },
        data() {
            return {
                isOpen: false,
            };
        },
        created() {
            // check if the active segment is starred in which case
            // we want to open the menu as it renders
            this.isOpen = this.activeSegment.isStarred;
        },
    };
</script>
